var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckboxOutlineChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.00195,
    width: 15,
    height: 15,
    rx: 1.5,
    fill: "#7048E8",
    stroke: "#7048E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.0001 11.2821L3.2201 8.50209L2.27344 9.44209L6.0001 13.1688L14.0001 5.16876L13.0601 4.22876L6.0001 11.2821Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxOutlineChecked);
export default __webpack_public_path__ + "static/media/checkbox_outline_checked.364d925b.svg";
export { ForwardRef as ReactComponent };